// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"YU-z","inlineTitle":"ZU-z","sponsoredAdsWrapper":"_U-z","marketplaceRecosWrapper":"aV-z"};